import { render } from "./YouTubeUploader.vue?vue&type=template&id=5b99c1da&scoped=true"
import script from "./YouTubeUploader.vue?vue&type=script&lang=js"
export * from "./YouTubeUploader.vue?vue&type=script&lang=js"

import "./YouTubeUploader.vue?vue&type=style&index=0&id=5b99c1da&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b99c1da"]])

export default __exports__